import { useSystemClassifierSelectOptions } from '../../configuration';

export function useKeyClassifiers() {
  const statusClassifiers = useSystemClassifierSelectOptions([
    'INDICATOR_STATUS',
  ]).INDICATOR_STATUS;
  const recipientClassifiers = useSystemClassifierSelectOptions([
    'REPORT_RECIPIENT',
  ]).REPORT_RECIPIENT;
  const ruleClassifiers = useSystemClassifierSelectOptions([
    'IND_STATUS_RULE_TYPE',
  ]).IND_STATUS_RULE_TYPE;
  const ruleValueClassifiers = useSystemClassifierSelectOptions([
    'IND_VALUE_RULE_TYPE',
  ]).IND_VALUE_RULE_TYPE;

  return {
    statusClassifiers,
    recipientClassifiers,
    ruleClassifiers,
    ruleValueClassifiers,
  };
}
